import { z } from 'zod'

import { RegistrationTypeSchema } from '@mntn-dev/app-routing'
import { FileUrlSchema, NonEmptyStringSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const cookieName = '__params' as const
export type CookieName = typeof cookieName

export const CookieParamsSchema = z
  .object({
    __type: RegistrationTypeSchema,
    __referenceFileUrl: FileUrlSchema,
    __qfaiProjectId: NonEmptyStringSchema(),
  })
  .partial()

export type CookieParams = ZodInfer<typeof CookieParamsSchema>

export const COOKIE_PARAMS_HEADER = 'x-cookie-params'
